import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify, {
  options: {
    customProperties: true,
  },
  theme: {
    // primary: colors.blue.darken2,
    // accent: colors.grey.darken3,
    // secondary: colors.amber.darken3,
    // info: colors.teal.lighten1,
    // warning: colors.amber.base,
    // error: colors.deepOrange.accent4,
    // success: colors.green.accent3
    primary: {
      base: '#00ab4d',
      darken2: '#009a3d',
    },
    secondary: '#80d5a6',
    accent: '#d56906',
    error: '#d32f2f',
    'near-black': '#262626',
  },
});
